module.exports = __webpack_public_path__ + "img/retail-4.31f9b914.png";